import { useCallback } from 'react';
import { getWorkLocationTypes } from '@Store/selectors/dictionarySelector';
import { TypeDict } from 'types';
import { useAppSelector } from '.';

interface ReturnedValue {
  findWorkLocationType: (requestTypeID: number) => TypeDict | undefined;
}

const useWorkLocationType = (): ReturnedValue => {
  const dictionaryTypes = useAppSelector(getWorkLocationTypes);

  const findWorkLocationType = useCallback(
    (requestTypeID: number): TypeDict | undefined =>
      dictionaryTypes.find((item) => item.codeNum === requestTypeID),
    [dictionaryTypes]
  );

  return { findWorkLocationType };
};

export default useWorkLocationType;
